import { MultiFeedMessage } from "../../sdk/types/api";

const getSubChannelClass = (subChannel: string) => {
  switch (subChannel) {
    case "orderbook":
      return "hooks-test-subchannel-orderbook";
    case "trades":
      return "hooks-test-subchannel-trades";
    case "positions":
      return "hooks-test-subchannel-positions";
    case "orders":
      return "hooks-test-subchannel-orders";
    case "buckets":
      return "hooks-test-subchannel-buckets";
    case "balances":
      return "hooks-test-subchannel-balances";
    default:
      return "hooks-test-subchannel-default";
  }
};

interface MultiFeedMessagesListProps {
  messages: MultiFeedMessage[];
  maxDisplay: number;
  onMessageClick: (message: MultiFeedMessage, title: string) => void;
}

export default function MultiFeedMessagesList({
  messages,
  maxDisplay,
  onMessageClick,
}: MultiFeedMessagesListProps) {
  if (messages.length === 0) {
    return (
      <div className="hooks-test-loading-state">
        No multi-feed messages received yet
      </div>
    );
  }

  return (
    <div className="hooks-test-multifeed-messages-container">
      <div className="hooks-test-multifeed-messages-list">
        {messages.map((message, idx) => {
          return (
            <div
              key={idx}
              className={`hooks-test-multifeed-message-item ${
                idx % 2 === 0
                  ? "hooks-test-multifeed-message-item-even"
                  : "hooks-test-multifeed-message-item-odd"
              }`}
              onClick={() =>
                onMessageClick(message, `Multi-Feed: ${message.sub_channel}`)
              }
            >
              <div className="hooks-test-multifeed-message-header">
                <span
                  className={`hooks-test-multifeed-message-subchannel ${getSubChannelClass(
                    message.sub_channel,
                  )}`}
                >
                  {message.sub_channel}
                </span>
                {message.sequence_id && (
                  <span className="hooks-test-multifeed-message-sequence">
                    Seq: {message.sequence_id}
                  </span>
                )}
              </div>
              <div className="hooks-test-multifeed-message-info">
                Market: {message.market_id || "N/A"}
                {message.first_sequence_id &&
                  ` | First SQ-ID: ${message.first_sequence_id}`}
                {message.last_sequence_id &&
                  ` | Last SQ-ID: ${message.last_sequence_id}`}
                {message.checksum &&
                  ` | Checksum: ${message.checksum.substring(0, 8)}...`}
              </div>
              <div className="hooks-test-multifeed-message-preview">
                {JSON.stringify(message.data).substring(0, 100)}...
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
